import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { twMerge } from "tailwind-merge";

function ComponentLoading({
  label = "Chargement",
  className,
  size = 40,
}: {
  label?: string;
  className?: string;
  size?: number;
}) {
  return (
    <div className={"flex items-center justify-center h-full w-full"}>
      <div>
        <div className="flex items-center justify-center text-2xl gap-4">
          <p className={twMerge(className)}>{label} </p>
          <CircularProgress sx={{ color: "#EE4540" }} size={size} />
        </div>
      </div>
    </div>
  );
}

export default ComponentLoading;
